module.exports = __webpack_public_path__ + "static/media/YDJSP.2be88ed8.jpg";